export default __webpack_public_path__ + "static/media/publisher_ads.df81abda.svg";